import React from 'react';
import PropTypes from 'prop-types';
import ButtonIcon from './../../common/ButtonIcon/ButtonIcon';
import EventModalItem from './EventModalItem/EventModalItem';
import './event-modal.scss';

const SKELETON_ROWS = [0, 1, 2];

const EventModal = ({
  events,
  loading,
  error,
  dateLabel,
  timezoneCity,
  timezoneOffsetLabel,
  toggleClass,
  closeModal,
  onRetry,
}) => {
  const renderBody = () => {
    // Скелетон замість «подій не заплановані»: раніше під час завантаження
    // показувалась заглушка порожнього дня — користувач бачив хибне «немає занять».
    if (loading) {
      return SKELETON_ROWS.map((row) => (
        <div className="event-modal__skeleton" key={row}>
          <span style={{ width: '45%' }} />
          <span style={{ width: '80%' }} />
          <span style={{ width: '60%' }} />
        </div>
      ));
    }

    if (error) {
      return (
        <div className="event-modal__plug event-modal__plug--error">
          {error}
          <button type="button" className="event-modal__retry" onClick={onRetry}>
            Спробувати ще
          </button>
        </div>
      );
    }

    if (!events.length) {
      return <div className="event-modal__plug">На вибрану дату події не заплановані.</div>;
    }

    return events.map((event) => (
      <EventModalItem key={event.id} event={event} closeModal={closeModal} />
    ));
  };

  return (
    <div className={`event-modal ${toggleClass}`}>
      <div className="overlay" onClick={closeModal}></div>
      <div className="event-modal__container">
        <div className="event-modal__head">
          <div className="event-modal__title">Події</div>
          <ButtonIcon
            classes={'event-modal__close'}
            icon='close'
            iconColor={'violet'}
            onClick={closeModal}
          />
        </div>

        {dateLabel && <div className="event-modal__date">{dateLabel}</div>}

        {/* На вузькому екрані панель перекриває календар, і підпис поясу над ним не видно —
            тому дублюємо його тут. Київському студенту (порожнє місто) не показуємо. */}
        {timezoneCity && (
          <div className="event-modal__tz">
            Час за вашим поясом: <b>{timezoneCity}</b>
            {timezoneOffsetLabel ? <span> · {timezoneOffsetLabel}</span> : null}
          </div>
        )}

        <div className="event-modal__body">{renderBody()}</div>
      </div>
    </div>
  );
};

EventModal.propTypes = {
  events: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  dateLabel: PropTypes.string,
  timezoneCity: PropTypes.string,
  timezoneOffsetLabel: PropTypes.string,
  toggleClass: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

EventModal.defaultProps = {
  loading: false,
  error: '',
  dateLabel: '',
  timezoneCity: '',
  timezoneOffsetLabel: '',
};

export default EventModal;
